// removed by extract-text-webpack-plugin
module.exports = {"header":"_1ULqj","lead":"_3FGhm"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/App.scss
 ** module id = 108
 ** module chunks = 0
 **/